function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M965.1,566.816v12.409a.323.323,0,0,0,.323.323h4.608a.323.323,0,0,0,.323-.323V566.613h3.341a.323.323,0,0,0,.322-.3l.322-3.8a.324.324,0,0,0-.322-.351h-3.662v-2.7a1.144,1.144,0,0,1,1.145-1.144h2.575A.324.324,0,0,0,974.4,558v-3.8a.323.323,0,0,0-.323-.323h-4.351A4.623,4.623,0,0,0,965.1,558.5v3.663h-2.3a.323.323,0,0,0-.323.323v3.8a.323.323,0,0,0,.323.323h2.3Z",
  transform: "translate(-962.472 -553.881)",
  fill: "#01174f",
  fillRule: "evenodd"
});

var SvgIconFacebook = function SvgIconFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.924,
    height: 25.667,
    viewBox: "0 0 11.924 25.667",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconFacebook.1e6ae923.svg";
export { ForwardRef as ReactComponent };